exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xs-table-with-filters .xs-server-grid {\n  padding: 10px 35px;\n}\n", ""]);

// exports
